import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { AiroService } from "../../services/airo.service";
import { ToastrService } from "ngx-toastr";
import { PageEvent } from "@angular/material/paginator";

@Component({
  selector: "app-airo-data-dialog",
  templateUrl: "./airo-data-dialog.component.html",
  styleUrls: ["./airo-data-dialog.component.scss"],
})
export class AiroDataDialogComponent implements OnInit {
  userQuery = "";
  response: any;
  isLoading = false;
  pageSize: number = 20;
  page: number = 1;
  queryResults: any;
  tableColumns: any = [];
  recordsCount: number = 0;

  constructor(
    public dialogRef: MatDialogRef<any>,
    private readonly airoService: AiroService,
    private readonly toastrService: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.userQuery = this.data.query;
    this.generateAnswer();
  }

  getAnswerData(answerId: number) {
    this.airoService
      .getAnswerResults(this.data.repoId, answerId, {
        page: this.page,
        number_of_records: this.pageSize,
      })
      .subscribe((res: any) => {
        if (res.success) {
          this.queryResults = res.data;
          if (this.queryResults.length) {
            this.tableColumns = Object.keys(this.queryResults[0]);
          } else {
            this.tableColumns = [];
          }
          this.recordsCount = res.total_records;
        } else {
          this.toastrService.error(res.message);
        }
        this.isLoading = false;
      });
  }

  generateAnswer() {
    this.isLoading = true;
    this.airoService
      .generateAnswer(this.data.repoId, this.userQuery)
      .subscribe((resp: any) => {
        this.response = resp.data;
        this.getAnswerData(resp.data.id);
      });
  }

  handlePageChange(event: PageEvent) {
    this.isLoading = true;
    this.airoService
      .getAnswerResults(this.data.repoId, this.response.id, {
        page: event.pageIndex + 1,
        number_of_records: event.pageSize,
      })
      .subscribe((res: any) => {
        if (res.success) {
          this.pageSize = event.pageSize;
          this.page = event.pageIndex + 1;
          this.queryResults = res.data;
        } else {
          this.toastrService.error(res.message);
        }
        this.isLoading = false;
      });
  }

  close() {
    this.dialogRef.close();
  }
}
